<template>
  <div style="height: 100%" v-title data-title="新手引导">
    <div style="margin: 20px 18px 0 18px" class="flex main-center cross-center">
      <a href="https://mp.weixin.qq.com/s/OZXf7uN5aX3HCVG_w5QxXA">
        <img class="noviceGuide" src="../assets/novice_guide_student_bg.png">
      </a>
    </div>
    <div class="flex main-center cross-center" style="width: 100%; margin-top: 70px">
      <img class="noviceGuideQuestions" src="../assets/noviceGuide_questions.png">
    </div>
    <div class="flex main-space-between" style="margin: 46px 48px 0">
      <div class="flex column main-center cross-center" @click="onAboutClick(0)">
        <img class="about_img" src="../assets/about_cer.png">
        <span class="about_text">关于班级</span>
      </div>
      <div class="flex column main-center cross-center" @click="onAboutClick(1)">
        <img class="about_img" src="../assets/about_class.png">
        <span class="about_text">关于闯关</span>
      </div>
      <div class="flex column main-center cross-center" @click="onAboutClick(2)">
        <img class="about_img" src="../assets/about_pass.png">
        <span class="about_text">关于课程</span>
      </div>
    </div>
    <div class="flex main-space-between" style="margin: 27px 48px 0">
      <div class="flex column main-center cross-center" @click="onAboutClick(3)">
        <img class="about_img" src="../assets/about_book.png">
        <span class="about_text">关于图书</span>
      </div>
      <div class="flex column main-center cross-center" @click="onAboutClick(4)">
        <img class="about_img" src="../assets/about_other.png">
        <span class="about_text">关于会员</span>
      </div>
      <div class="flex column main-center cross-center" @click="onAboutClick(5)">
        <img class="about_img" src="../assets/about_other.png">
        <span class="about_text">其他问题</span>
      </div>
    </div>
  </div>
</template>

<script>
  /// 新手引导
  export default {
    name: "NoviceGuide",
    methods:{
      onAboutClick: function (index) {
        switch (index) {
          case 0:{
            this.$router.push({name:'AboutStudentClass'})
          }
            break;
          case 1:{
            this.$router.push({name:'AboutStudentPass'})
          }
            break;
          case 2:{
            this.$router.push({name:'AboutStudentCourse'})
          }
            break;
          case 3:{
            this.$router.push({name:'AboutStudentBook'})
          }
            break;
          case 4:{
            this.$router.push({name:'AboutStudentMember'})
          }
            break;
          case 5:{
            this.$router.push({name:'AboutStudentOther'})
          }
            break;
        }
      }
    }
  }
</script>

<style scoped>
  .noviceGuide{
    width: calc(340 / 375 * 100vw);
    height: calc(142 / 375 * 100vw);
  }
  .noviceGuideQuestions{
    width: auto;
    height: calc(24 / 375 * 100vw);
  }
  .about_img {
    width: calc(36 / 375 * 100vw);
    height: calc(30 / 375 * 100vw);
  }
  .about_text {
    color: #666666FF;
    font-size: calc(13 / 375 * 100vw);
  }
</style>



// WEBPACK FOOTER //
// src/components/NoviceGuideStudent.vue